import axios from '../../axios/index'
import { isObject } from "my-tools-kit";

export function getSelectItemAll() {
  return {
    label: '全部',
    value: '',
  }
}
import {mapFromArrayToObject,mapArrayObjectKeyName} from "./utils";

/**
 * 获取 物流产品列表(改)
 */
 export function getLineProductListByCarrierId(keyName = 'productList', unshiftAll = true) {
  return axios.get('/carrier/productPriceNew/getLineProductListByCarrierId')
    .then(res => {
      if (res.data.code !== 200) {
        this.$message.info(res.data.message || "服务器繁忙");
        return Promise.reject(new Error(res.data.message || "服务器繁忙"));
      }
      let list = res.data.datas;
      let prop = {label: 'productName', value: 'logisticsProductId'};
      mapArrayObjectKeyName(list, prop);
      if (unshiftAll) list.unshift(getSelectItemAll());
      if (keyName) {
        this[keyName] = list;
        this[keyName + 'MapObject'] = mapFromArrayToObject.call(this, list);
      }
      return Promise.resolve(res.datas);
    }).catch(res => {
      if (keyName) {
        this[keyName] = [];
        this[keyName + 'MapObject'] = {};
      }
      return Promise.reject(res);
    })
}

/**
 * 获取 物流产品列表
 */
export function getProductList(keyName = 'productList', unshiftAll = true) {
  return axios.get('/carrier/productPriceNew/getProductListByCarrierId')
    .then(res => {

      if (res.data.code !== 200) {
        this.$message.info(res.data.message || "服务器繁忙");
        return Promise.reject(new Error(res.data.message || "服务器繁忙"));
      }
      let list = res.data.datas;
      let prop = {label: 'name', value: 'id'};
      mapArrayObjectKeyName(list, prop);
      if (unshiftAll) list.unshift(getSelectItemAll());
      if (keyName) {
        this[keyName] = list;
        this[keyName + 'MapObject'] = mapFromArrayToObject.call(this, list);
      }
      return Promise.resolve(res.datas);
    }).catch(res => {
      if (keyName) {
        this[keyName] = [];
        this[keyName + 'MapObject'] = {};
      }
      return Promise.reject(res);

    })
}

/**
 * 获取登陆用户最新信息
 */
export function getUserLoginInfo() {
  let url = "/api/user/getUserLoginInfo/1";
  return axios.get(url)
    .then(res => {
      res = isObject(res.data) ? res.data : {};
      if (res.code !== 200) return Promise.reject(new Error(res.message));
      return res;
    })
    .then(res => {
      let data = res.data || {};
      // loginSaveUserData(data);
      return res;
    })
}

/**
 * 根据运输方式获取尾端派送类型
 * @param {*} transportType
 * @returns
 */
export function getDeliveryTypeByTransportType (transportType) {
  let url = `/api/filedata/findDeliveryTypeByTransport?transportType=${transportType}`;
  return axios.get(url)
    .then(res => {
      if (res.data.code !== 200) return Promise.reject(new Error(res.data.message));
      return Promise.resolve(res.data.datas);
    })
    .catch(res => {
      return Promise.reject(res);
    })
}

/**
 * 获取所有船公司
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getShippingCompany() {
  return axios.get('/api/filedata/findShippingCompanyAll')
    .then(res => {
      if (res.data.code === 200) {
        return Promise.resolve(res.data.datas)
      } else {
        return Promise.reject(res)
      }
    }).catch(err => {
      return Promise.reject(err)
    })
}

/**
 * 获取中转港口下拉
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getTransitPort() {
  return axios.get('/api/fullContainerPrice/transitPortList')
    .then(res => {
      if (res.data.code === 200) {
        return Promise.resolve(res.data.datas)
      } else {
        return Promise.reject(res)
      }
    }).catch(err => {
      return Promise.reject(err)
    })
}

/**
 * 获取海运费下拉 1.起运港拖车费 2.国内报关费 3.海运费 4.目的港清关费 5.目的港拖车费 6.起运港附加费 7.目的港附加费 8.其它费用
 * @param type
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getHyFeeList(type) {
  return axios.get(`/api/fullContainerPrice/fullContainerDropDownExpense?type=${type}`)
    .then(res => {
      if (res.data.code === 200) {
        return Promise.resolve(res.data.datas)
      } else {
        return Promise.reject(res)
      }
    }).catch(err => {
      return Promise.reject(err)
    })
}

/**
 * 整柜柜型下拉
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getContainerTypeList() {
  return axios.post('/api/fullContainerPrice/fullContainerCabinetTypeList')
    .then(res => {
      if (res.data.code === 200) {
        return Promise.resolve(res.data.datas)
      } else {
        return Promise.reject(res)
      }
    }).catch(err => {
      return Promise.reject(err)
    })
}

/**
 * 币种下拉
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getCurrencyList() {
  return axios.post('/api/fullContainerPrice/fullContainerCurrencyList')
    .then(res => {
      if (res.data.code === 200) {
        return Promise.resolve(res.data.datas)
      } else {
        return Promise.reject(res)
      }
    }).catch(err => {
      return Promise.reject(err)
    })
}

/**
 * 发送客户操作记录（客户留存数据分析埋点）
 * @param operationButtonName  {string}  操作按钮（类型）名称
 * @param operationContent {string}  操作内容描述
 * @param optionsData {object} 补充请求参数
 * @returns {boolean}
 */
export function sendCustomerOperationRecord(operationButtonName="",operationContent="", optionsData = {}){
  let url = "/api/sysUserOperationLog/addSysUserOperationLog";
  let useInfo = localStorage.getItem("Authorization_lineSupplier");
  useInfo = JSON.parse(useInfo);
  let isLogin = useInfo && useInfo.customerid && useInfo.token;
  if(!isLogin) {
    // return Promise.reject( new Error("未登录"));
    return false;
  }
  let data = {
    // 客户id
    "customerId": useInfo.customerid,
    // 操作按钮名称
    "operationButtonName": operationButtonName,
    // 操作内容
    "operationContent": operationContent,
    // 类型 1：Web端；2：小程序
    "type": 1,
    // 用户id
    "userId": useInfo.userId,
    // 用户登录类型 1: 免密；2： 密码；3：验证码
    "loginType": useInfo.loginType,
    ...optionsData
  }
  useInfo.loginType === 1 ? data.operationButtonName += "(免密)" : null;
  axios.post(url,data)
    .then(res=>{
      res = isObject(res.data) ? res.data : {};
      if(res.code !== 200) return Promise.reject(new Error(res.message));
      return res;
    })
    .then(res=>{

    })
    .catch(res=>{
      console.error(res);
    })
}

/**
 * 获取国家列表
 * @returns {Promise}
 */
export function getCountryList() {
  return axios.get('/fullContainerPrice/getCountryList')
    .then(res => {
      if (res.data.code !== 200) return Promise.reject(new Error(res))
      return Promise.resolve(res.data.datas)
    })
    .catch(res => {
      return Promise.reject(new Error(res))
    })
}

/**
 * 根据国家id获取港口
 * @param {number|string} countryId 国家id
 * @returns {Promise}
 */
export function getPortByCountry(countryId) {
  return axios.get(`/fullContainerPriceInfoTemplate/getCityPortSelectItems?countryId=${countryId}`)
    .then(res => {
      if (res.data.code === 200) {
        let list = res.data.datas
        list.forEach(item => {
          if (item.type === 1) {
            item.namec = `${item.portNamec}，${item.cityNamec}，${item.countryNamec} (${item.portCode})`
            item.namee = `${item.portNamee},${item.cityNamee},${item.countryNamee}`
          } else {
            item.namec = `${item.cityNamec}，${item.countryNamec}`
            item.namee = `${item.cityNamee},${item.countryNamee}`
          }
        })
        // list.unshift({ namec: '全部', id: '' })
        return Promise.resolve(list)
      }
      return Promise.reject(new Error(res))
    })
    .catch(res => {
      return Promise.reject(new Error(res))
    })
}

/**
 * 获取专线供应商下拉
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getLineList() {
  return axios.get('/fbaTailCourseOrder/getCustomerSelectItems')
    .then(res => {
      if (res.data.code === 200) {
        return Promise.resolve(res.data.datas)
      }
      return Promise.reject(new Error(res))
    })
    .catch(res => {
      return Promise.reject(new Error(res))
    })
}



// WEBPACK FOOTER //
// ./src/assets/js/baseDataRuquest.js